import React from "react";
import CustomTable from "../../../../../../components/table/table";
import "../style.css";

export default function View(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  {
    console.log(props?.basicData);
  }
  return (
    <div>
      <div className="view-container">
        <h6>
          <b>Vendor Details</b>
        </h6>

        <hr />

        <div className="data">
          <div className="row">
            <div className="col-3">Company Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.company_name ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Address</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.address ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Logo</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.logo_name ?? ""}</div>
          </div>

          <div className="row">
            <div className="col-3">Area of Operation/Expertise</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.area_of_operation ?? ""}
            </div>
          </div>

          <div className="row">
            <div className="col-3"> Brief Company Description</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.company_description ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Contact Person Name</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.name ?? ""}</div>
          </div>

          <div className="row">
            <div className="col-3">Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.phone_number ?? ""}</div>
          </div>

          <div className="row">
            <div className="col-3">Email</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.email}</div>
          </div>
          <div className="row">
            <div className="col-3">Alternate Phone Number</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.alt_country_code ?? ""}{" "}
              {props.basicData.alternate_phone ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Alternate Email</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.alternate_email}</div>
          </div>
          <div className="row">
            <div className="col-3">Brochure</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.brochure_name}</div>
          </div>
        </div>

        <div className="footer-buttons mt-3">
          <div
            className="secondary-btn"
            onClick={(e) => {
              props.action(1);
            }}
          >
            GO BACK
          </div>
          <div
            className="primary-btn"
            onClick={(e) => {
              props.action(2);
            }}
          >
            REGISTER
          </div>
        </div>
      </div>
    </div>
  );
}
